import "./styles/app.css";
import { App } from "./app/App";

const canvas = document.getElementById("game") as HTMLCanvasElement | null;
const uiRoot = document.getElementById("ui") as HTMLDivElement | null;

if (!canvas || !uiRoot) {
  throw new Error("Canvas/UI introuvables dans index.html");
}

const app = new App({ canvas, uiRoot });
app.start();
